import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getSkills,
  getSingleSkill,
  createSkill,
  updateSkill,
  deleteSkill,
} from "../Api/skill";
import { Skill, SkillDetail, SkillPayload } from "../Models/skill";

export const useSkills = () => {
  return useQuery<Skill[], Error>({
    queryKey: ["skills"],
    queryFn: () => getSkills(),
  });
};

export const useSingleSkill = (skillId: number) => {
  return useQuery<SkillDetail, Error>({
    queryKey: ["skill", skillId],
    queryFn: () => getSingleSkill(skillId),
    enabled: !!skillId,
  });
};

export const useCreateSkill = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SkillPayload) => createSkill(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["skills"] });
    },
  });
};

export const useUpdateSkill = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables: { skillId: number; data: SkillPayload }) =>
      updateSkill(variables.skillId, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["skills"] });
      queryClient.invalidateQueries({ queryKey: ["skill", variables.skillId] });
    },
  });
};

export const useDeleteSkill = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (skillId: number) => deleteSkill(skillId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["skills"] });
    },
  });
};
